export function collaborationInvitationLinkUrl({
  contextType,
  collaborationId,
  itemUrl,
  itemName,
  inviterName,
}: {
  readonly contextType: 'project' | 'contest';
  readonly collaborationId: number;
  readonly itemUrl: string;
  readonly itemName?: string;
  readonly inviterName?: string;
}): string {
  const params = new URLSearchParams({ itemUrl });
  if (itemName) {
    params.set('itemName', itemName);
  }
  if (inviterName) {
    params.set('inviterName', inviterName);
  }
  return `/collaboration-invitation/${contextType}/${collaborationId}?${params.toString()}`;
}
